import {
	CHECKOUT_SUMMARY_REQUEST,
	CHECKOUT_SUMMARY_SUCCESS,
	CHECKOUT_SUMMARY_ERROR,
	CHECKOUT_SUMMARY_CLEAR
} from 'actions/CheckoutActions/checkoutSummaryActions';
import {
	UPDATE_CHECKOUT_QUANTITY_REQUEST,
	UPDATE_CHECKOUT_QUANTITY_SUCCESS,
	UPDATE_CHECKOUT_QUANTITY_ERROR,
	UPDATE_DELIVERY_PROMISE_REQUEST,
	UPDATE_DELIVERY_PROMISE_SUCCESS,
	UPDATE_DELIVERY_PROMISE_ERROR,
	REMOVE_CHECKOUT_ITEM_REQUEST,
	REMOVE_CHECKOUT_ITEM_SUCCESS,
	REMOVE_CHECKOUT_ITEM_ERROR,
	UPDATE_CHECKOUT_EMAIL_REQUEST,
	UPDATE_CHECKOUT_EMAIL_SUCCESS,
	UPDATE_CHECKOUT_EMAIL_ERROR,
	CHANGE_DELIVERY_SLOT_REQUEST,
	CHANGE_DELIVERY_SLOT_SUCCESS,
	CHANGE_DELIVERY_SLOT_ERROR
} from 'actions/CheckoutActions/checkoutEditActions';
import {
	ADDRESS_DELIVER_SELECT_REQUEST,
	ADDRESS_DELIVER_SELECT_SUCCESS,
	ADDRESS_DELIVER_SELECT_ERROR,
	UPSERT_ADDRESS_REQUEST,
	UPSERT_ADDRESS_SUCCESS,
	UPSERT_ADDRESS_ERROR
} from 'actions/CheckoutActions/addressActions';

import {
	GET_ADDRESS_FROM_LAT_LNG_REQUEST,
	GET_ADDRESS_FROM_LAT_LNG_SUCCESS,
	GET_ADDRESS_FROM_LAT_LNG_ERROR
} from 'actions/addressFromLatLngActions';

import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';

const INITIAL_STATE = INIT;

export default function checkoutAsyncStatus(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case CHECKOUT_SUMMARY_REQUEST:
		case UPDATE_CHECKOUT_QUANTITY_REQUEST:
		case CHANGE_DELIVERY_SLOT_REQUEST:
		case UPDATE_DELIVERY_PROMISE_REQUEST:
		case REMOVE_CHECKOUT_ITEM_REQUEST:
		case UPDATE_CHECKOUT_EMAIL_REQUEST:
		case ADDRESS_DELIVER_SELECT_REQUEST:
		case UPSERT_ADDRESS_REQUEST:
		case GET_ADDRESS_FROM_LAT_LNG_REQUEST:
			return LOADING;

		case CHECKOUT_SUMMARY_SUCCESS:
		case CHANGE_DELIVERY_SLOT_SUCCESS:
		case UPDATE_CHECKOUT_QUANTITY_SUCCESS:
		case UPDATE_DELIVERY_PROMISE_SUCCESS:
		case UPDATE_CHECKOUT_EMAIL_SUCCESS:
		case REMOVE_CHECKOUT_ITEM_SUCCESS:
		case ADDRESS_DELIVER_SELECT_SUCCESS:
		case UPSERT_ADDRESS_SUCCESS:
		case GET_ADDRESS_FROM_LAT_LNG_SUCCESS:
			return SUCCESS;

		case CHANGE_DELIVERY_SLOT_ERROR:
		case UPDATE_CHECKOUT_QUANTITY_ERROR:
		case CHECKOUT_SUMMARY_ERROR:
		case UPDATE_DELIVERY_PROMISE_ERROR:
		case REMOVE_CHECKOUT_ITEM_ERROR:
		case UPDATE_CHECKOUT_EMAIL_ERROR:
		case ADDRESS_DELIVER_SELECT_ERROR:
		case UPSERT_ADDRESS_ERROR:
		case GET_ADDRESS_FROM_LAT_LNG_ERROR:
			return ERROR;
		case CHECKOUT_SUMMARY_CLEAR:
			return INITIAL_STATE;
		default:
			return state;
	}
}
